import * as Immutable from "immutable";

const initialState = Immutable.Map({
  lastUpdatedTimestamp: null
});

/**
 * @param {Object} state
 * @param {Object} action
 * @returns {Object}
 */
export default function analyticsPage(state = initialState, action) {
  switch (action.type) {
    case "SET_ANALYTICS_LAST_UPDATED_TIMESTAMP": {
      return state.set("lastUpdatedTimestamp", action.value);
    }

    default: {
      return state;
    }
  }
}
